export default {"src":"/_next/static/media/circle.e511475a.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};